import React, { useMemo, useState } from "react";
import "../../../../App.scss";
import Header from "../../../../Components/MandG/Header";
import Page4 from "../MandG/page4";
import Page5 from "../MandG/page5";

const Index = (props) => {
  const [step, setStep] = useState(0);
  const [skippedQuestion, setSkippedQuestion] = useState(false);

  const safeModuleObject = useMemo(() => {
    const questions = props.moduleObject?.questions || [];
    if (questions.length >= 2) {
      // Page4 and Page5 expect indexes 3 and 4, so pad preceding slots
      const padded = [{}, {}, {}, questions[0], questions[1]];
      return { ...props.moduleObject, questions: padded };
    }
    return { ...props.moduleObject, questions };
  }, [props.moduleObject]);

  return (
    <div
      className="exp-mandg-scroll"
      style={{
        width: "100%",
        height: "100%",
        minHeight: "100%",
        position: "absolute",
        backgroundColor: "var(--game-background-color-exp)",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Header currentRoute={"Understanding"} />
      {step === 0 ? (
        <Page4
          {...props}
          moduleObject={safeModuleObject}
          Refresh={() => setStep(1)}
          setSkippedQuestion={setSkippedQuestion}
          skippedQuestion={skippedQuestion}
          ignoreAskIf
        />
      ) : (
        <Page5
          {...props}
          moduleObject={safeModuleObject}
          setSkippedQuestion={setSkippedQuestion}
          skippedQuestion={skippedQuestion}
        />
      )}
    </div>
  );
};

export default Index;
